// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2KizC","actionsCol":"EnrolledClinics_actionsCol__1yiZ4"};